module.exports = __webpack_public_path__ + "img/non-smoking-inactive.710d75af.svg";